<template>
  <va-form class="mt-5" tag="form" @submit.prevent="addAdmin">
    <va-input v-model="admin.name" :label="$t('name')" required />

    <va-input
      class="mt-4"
      v-model="admin.email"
      type="email"
      :label="$t('email')"
      required
    />
    <va-input
      class="mt-4"
      v-model="admin.tel"
      :label="$t('tel')"
      placeholder="+### ##########"
      :mask="{ blocks: [3, 9] }"
      required
    />
    <va-input
      class="mt-4"
      v-model="admin.password"
      type="password"
      :label="$t('password')"
      required
    />

    <va-button type="submit" class="mt-4" :disabled="checkForm" :loading="loading">
      {{ $t("add") }}
    </va-button>
  </va-form>
</template>

<script>
import { gql, request } from "graphql-request";
export default {
  name: "add-admin-form",
  data() {
    return {
      loading: false,
      admin: { name: "", password: "", tel: null, email: "" },
    };
  },
  methods: {
    async addAdmin() {
      const ADD_ADMIN = gql`
        mutation (
          $name: String
          $email: String
          $tel: String
          $lang: String
          $password: String
        ) {
          register(
            registerInput: {
              name: $name
              email: $email
              tel: $tel
              password: $password
              lang: $lang
            }
          ) {
            id
          }
        }
      `;
      const UPDATE_USER_ROLE = gql`
        mutation ($id: Int) {
          UsersUpdate(users: { id: $id, user_role_id: 2 }) {
            name
          }
        }
      `;
      try {
        this.loading = true;
        const response = await request(
          this.$store.state.appUrl,
          ADD_ADMIN,
          this.admin
        );
        await request(this.$store.state.appUrl, UPDATE_USER_ROLE, {
          id: response.register.id,
        });
        this.getAdmins;
        this.loading = false;
        document.querySelector(".va-modal__close").click();
        this.$swal.fire({
          icon: "success",
          title: this.$t("success"),
          text: this.$t("add_admin_success"),
          confirmButtonColor: "#023b81",
          confirmButtonText: this.$t("ok"),
        });
      } catch (error) {
        this.loading = false;
        console.log(error);
        this.$swal.fire({
          icon: "error",
          title: this.$t("failed"),
          text: this.$t("add_admin_fail"),
          confirmButtonColor: "#023b81",
          confirmButtonText: this.$t("ok"),
        });
      }
    },
  },
  provide: ["getAdmins"],
  computed: {
    checkForm() {
      if (
        !this.admin.name ||
        !this.admin.email ||
        !this.admin.password ||
        !this.admin.tel
      )
        return true;
    },
  },
};
</script>
